export default {
  "content": "<path d=\"M10.5 4H5v16h11v-3h2v3a2 2 0 01-2 2H5a2 2 0 01-2-2V4a2 2 0 012-2h5.5v2z\" fill=\"#7B61FF\"/><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M15.586 2a2 2 0 012.828 0L23 6.586a2 2 0 010 2.828L18.414 14a2 2 0 01-2.828 0L14 12.414l-1.293 1.293-1.414-1.414L12.586 11 11 9.414a2 2 0 010-2.828L15.586 2zm-3.172 6L17 12.586 21.586 8 17 3.414 12.414 8z\" fill=\"#7B61FF\"/>",
  "attrs": {
    "width": "24",
    "height": "24",
    "viewBox": "0 0 24 24",
    "fill": "none",
    "xmlns": "http://www.w3.org/2000/svg"
  }
};